import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../config/config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    configureAxios();
  }, []);


  useEffect(() => {
    const loadUser = async () => {
      if (token) {
        setAuthToken(token);
        try {
          const res = await axios.get('https://hasanhaji.com/api/auth/me');
          setUser(res.data.data.user);
          setIsAuthenticated(true);
        } catch (err) {
          localStorage.removeItem('token');
          setToken(null);
          setUser(null);
          setIsAuthenticated(false);
          setError('Authentication failed. Please login again.');
        }
      }
      setLoading(false);
    };

    loadUser();
  }, [token]);


  const configureAxios = () => {
    axios.defaults.baseURL = getApiBaseUrl();
  };


  const setAuthToken = (token) => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      localStorage.setItem('token', token);
    } else {
      delete axios.defaults.headers.common['Authorization'];
      localStorage.removeItem('token');
    }
  };


  const register = async (formData) => {
    try {
      const res = await axios.post('https://hasanhaji.com/api/auth/signup', formData);
      setToken(res.data.token);
      setUser(res.data.data.user);
      setIsAuthenticated(true);
      setLoading(false);
      setError(null);
      return res.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
      return { error: err.response?.data?.message || 'Registration failed' };
    }
  };


  const login = async (formData) => {
    try {
      const res = await axios.post('https://hasanhaji.com/api/auth/login', formData);
      setToken(res.data.token);
      setUser(res.data.data.user);
      setIsAuthenticated(true);
      setLoading(false);
      setError(null);
      return res.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
      return { error: err.response?.data?.message || 'Login failed' };
    }
  };


  const logout = () => {
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    setAuthToken(null);
  };


  const updateProfile = async (formData) => {
    try {
      const res = await axios.patch('https://hasanhaji.com/api/auth/updateMe', formData);
      setUser(res.data.data.user);
      setError(null);
      return res.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Profile update failed');
      return { error: err.response?.data?.message || 'Profile update failed' };
    }
  };


  const updatePassword = async (data) => {
    try {
      const res = await axios.patch('https://hasanhaji.com/api/auth/updateMyPassword', data);
      setToken(res.data.token);
      setUser(res.data.data.user);
      setIsAuthenticated(true);
      setError(null);
      return { success: true };
    } catch (err) {
      setError(err.response?.data?.message || 'Password update failed');
      return { error: err.response?.data?.message || 'Password update failed' };
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isAuthenticated,
        loading,
        error,
        register,
        login,
        logout,
        updateProfile,
        updatePassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
